import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";

const LocationCity = (props) => (
  <Svg
    width={47}
    height={47}
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={47} height={47} rx={12} fill="#E40046" fillOpacity={0.1} />
    <G clipPath="url(#clip0_1_3)">
      <Path d="M37 20.433H31.8945V36.7145H37V20.433Z" fill="white" />
      <Path
        d="M16.5695 15.9193H13.5527V35.9888H16.5695V15.9193Z"
        fill="white"
      />
      <Path
        d="M31.1795 12.4545H26.1777V36.1511H31.1795V12.4545Z"
        fill="white"
      />
      <Path
        d="M10 35.5065V16.3836C10.2324 15.5377 10.6365 14.8811 11.6283 14.86C11.9954 14.86 12.3684 14.86 12.7311 14.86H15.7464C15.7464 14.0442 15.7286 13.3485 15.7464 12.6543C15.776 11.6611 16.4007 11.018 17.3747 11.0135C20.7072 11.0015 24.0393 11.0015 27.3709 11.0135C28.3345 11.0135 28.9666 11.6671 28.9829 12.6663C29.0051 14.0336 28.9829 15.4025 28.9829 16.7698V19.0521C30.2648 19.0521 31.4594 19.0521 32.654 19.0521C34.1342 19.0521 34.6464 19.5585 34.6479 21.0565C34.6479 25.6829 34.633 30.3092 34.6612 34.9355C34.6612 35.8791 34.3829 36.5718 33.5451 37.0015H11.1768C10.8818 36.8592 10.6226 36.6506 10.4187 36.3916C10.2148 36.1326 10.0716 35.8299 10 35.5065ZM17.2622 12.5176V35.4584H19.9903C19.9903 34.4216 20.0036 33.4315 19.9903 32.4413C19.977 31.7396 20.2952 31.4481 20.9732 31.4631C21.8613 31.4827 22.7377 31.4631 23.6199 31.4631C24.5599 31.4631 24.7301 31.6389 24.7345 32.596C24.739 33.5532 24.7345 34.5133 24.7345 35.4509H27.4538V12.5191L17.2622 12.5176ZM15.7153 16.3881H11.5839V35.4554H15.7153V16.3881ZM33.1187 35.4704V20.5742H29.0421V35.4704H33.1187ZM21.5165 32.9807V35.4464H23.2039V32.9807H21.5165Z"
        fill="black"
      />
      <Path
        d="M17.2618 12.519H27.4504V35.4569H24.7312C24.7312 34.5208 24.7312 33.5621 24.7312 32.602C24.7312 31.6419 24.5565 31.4721 23.6165 31.4691C22.7284 31.4691 21.852 31.4826 20.9698 31.4691C20.2918 31.4541 19.9736 31.7456 19.9869 32.4473C20.0047 33.4374 19.9869 34.4276 19.9869 35.4644H17.2588L17.2618 12.519ZM24.3803 18.0349C23.1487 18.0349 23.0022 18.1851 22.9993 19.3661C22.9993 20.6779 23.1325 20.8281 24.3315 20.8296C25.6045 20.8296 25.7421 20.6974 25.7421 19.4533C25.7421 18.1581 25.6237 18.0364 24.3803 18.0349ZM20.3451 18.0349C19.1091 18.0349 18.9774 18.1626 18.9759 19.3706C18.9759 20.6914 19.1002 20.8281 20.3081 20.8296C21.5767 20.8296 21.7232 20.6884 21.7232 19.4503C21.7203 18.1701 21.59 18.0364 20.3451 18.0349ZM20.3806 24.903C21.5871 24.903 21.7129 24.7693 21.7129 23.5402C21.7129 22.263 21.593 22.1398 20.3348 22.1398C19.0766 22.1398 18.9699 22.242 18.9699 23.5432C18.9773 24.8053 19.078 24.903 20.3806 24.903ZM25.7421 23.4951C25.7421 22.2585 25.6252 22.1428 24.4025 22.1428C23.1206 22.1428 22.9993 22.26 22.9993 23.5162C22.9993 24.7723 23.1206 24.906 24.3818 24.906C25.643 24.906 25.7421 24.7963 25.7421 23.4951ZM20.3629 13.9675C19.0721 13.9675 18.9774 14.0561 18.9759 15.2627C18.9759 16.636 19.0455 16.7141 20.283 16.7156C21.5974 16.7156 21.7173 16.6075 21.7188 15.3814C21.7203 14.0817 21.6122 13.969 20.3629 13.9675ZM24.3507 16.7156C25.6459 16.7156 25.7481 16.624 25.7496 15.428C25.7496 14.0652 25.6667 13.969 24.4499 13.9675C23.1176 13.9675 23.0081 14.0712 23.0066 15.2912C22.9977 16.621 23.094 16.7156 24.3507 16.7156ZM20.4162 26.2373C19.0987 26.2373 18.9788 26.3409 18.9759 27.4829C18.9759 28.9088 19.0454 28.9854 20.3081 28.9854C21.6063 28.9854 21.7203 28.8757 21.7218 27.6241C21.7232 26.3725 21.5945 26.2373 20.4162 26.2373ZM25.7451 27.6346C25.7451 26.353 25.64 26.2388 24.4528 26.2373C23.1206 26.2373 23.0051 26.3469 23.0022 27.555C23.0022 28.8742 23.1088 28.9914 24.3344 28.9929C25.6444 28.9899 25.7421 28.8953 25.7421 27.6301L25.7451 27.6346Z"
        fill="white"
      />
      <Path
        d="M33.1186 35.4795H29.042V20.5833H33.1186V35.4795ZM31.0818 30.7299C29.8354 30.7299 29.717 30.8456 29.717 32.0582C29.717 33.3819 29.8339 33.5126 31.0374 33.5141C32.3134 33.5141 32.4496 33.3834 32.4496 32.1393C32.451 30.8501 32.3356 30.7299 31.0818 30.7299ZM31.0552 25.3358C32.3238 25.3358 32.4496 25.2111 32.4496 23.9444C32.4496 22.6778 32.3119 22.5396 31.1395 22.5381C29.8428 22.5381 29.717 22.6553 29.717 23.8903C29.7155 25.2186 29.828 25.3358 31.0552 25.3358ZM31.0256 29.4017C32.3386 29.4017 32.4481 29.2995 32.4496 28.0644C32.4496 26.7767 32.346 26.6595 31.1647 26.658C29.7762 26.658 29.717 26.7076 29.717 27.9577C29.7155 29.331 29.7792 29.4017 31.0256 29.4017Z"
        fill="white"
      />
      <Path
        d="M21.5166 32.9897H23.2041V35.4554H21.5166V32.9897Z"
        fill="white"
      />
      <Path
        d="M24.3811 18.0349C25.6245 18.0349 25.7429 18.1581 25.7429 19.4533C25.7429 20.6974 25.6053 20.8312 24.3322 20.8296C23.1332 20.8296 23 20.6794 23 19.3662C23.003 18.1777 23.1495 18.0349 24.3811 18.0349Z"
        fill="black"
      />
      <Path
        d="M20.3454 18.0349C21.5903 18.0349 21.7205 18.1701 21.7191 19.4503C21.7191 20.6884 21.571 20.8311 20.3039 20.8296C19.1005 20.8296 18.9717 20.6914 18.9717 19.3707C18.9776 18.1626 19.1093 18.0349 20.3454 18.0349Z"
        fill="black"
      />
      <Path
        d="M20.3813 24.903C19.0787 24.903 18.978 24.8053 18.9766 23.5507C18.9766 22.2495 19.0757 22.1473 20.3414 22.1473C21.607 22.1473 21.721 22.2705 21.7195 23.5477C21.7195 24.7693 21.5877 24.903 20.3813 24.903Z"
        fill="black"
      />
      <Path
        d="M25.7429 23.4952C25.7429 24.7964 25.6408 24.9031 24.3825 24.9031C23.1243 24.9031 23 24.7814 23 23.5132C23 22.2451 23.1214 22.1384 24.4033 22.1399C25.626 22.1414 25.7414 22.2586 25.7429 23.4952Z"
        fill="black"
      />
      <Path
        d="M20.3636 13.9675C21.6129 13.9675 21.721 14.0817 21.7195 15.3814C21.7195 16.6075 21.5981 16.7187 20.2837 16.7157C19.0462 16.7157 18.9751 16.636 18.9766 15.2627C18.9781 14.0562 19.0728 13.9675 20.3636 13.9675Z"
        fill="black"
      />
      <Path
        d="M24.3509 16.7157C23.1016 16.7157 23.0054 16.6135 23.0069 15.2913C23.0069 14.0712 23.1238 13.966 24.4501 13.9675C25.6669 13.9675 25.7513 14.0652 25.7498 15.428C25.7409 16.621 25.6388 16.7172 24.3509 16.7157Z"
        fill="black"
      />
      <Path
        d="M20.4169 26.2373C21.6011 26.2373 21.721 26.3725 21.7195 27.6317C21.7181 28.8908 21.6041 28.9945 20.3059 28.993C19.0462 28.993 18.9736 28.9088 18.9736 27.4904C18.9796 26.3365 19.0995 26.2373 20.4169 26.2373Z"
        fill="black"
      />
      <Path
        d="M25.7427 27.6302C25.7427 28.8953 25.645 28.9825 24.3365 28.9825C23.1064 28.9825 22.9968 28.8638 23.0042 27.5445C23.0042 26.3425 23.1286 26.2253 24.4549 26.2268C25.6376 26.2373 25.7427 26.3485 25.7427 27.6302Z"
        fill="black"
      />
      <Path
        d="M13.6931 22.505C14.9202 22.505 15.0075 22.6027 15.0075 23.9565C15.0075 25.1585 14.8847 25.2787 13.6294 25.2787C12.3742 25.2787 12.269 25.1525 12.2705 23.8543C12.269 22.6102 12.3816 22.5035 13.6931 22.505Z"
        fill="black"
      />
      <Path
        d="M15.0051 28.0013C15.0051 29.2604 14.8881 29.3731 13.5988 29.3731C12.3998 29.3731 12.2666 29.2349 12.2666 27.9923C12.2666 26.7121 12.3968 26.5784 13.6432 26.5784C14.8896 26.5784 15.0051 26.7076 15.0051 28.0013Z"
        fill="black"
      />
      <Path
        d="M13.6116 18.4241C14.901 18.4241 15.0031 18.5172 15.0046 19.7163C15.0046 21.0866 14.9232 21.1782 13.7064 21.1797C12.3742 21.1797 12.2661 21.0821 12.2676 19.7779C12.2691 18.5353 12.3815 18.4241 13.6116 18.4241Z"
        fill="black"
      />
      <Path
        d="M15.0047 32.0972C15.0047 33.3654 14.9232 33.4495 13.594 33.4405C12.3787 33.4405 12.2691 33.3248 12.2617 32.0747C12.2617 30.781 12.355 30.6924 13.7198 30.6954C14.9232 30.6984 15.0047 30.7885 15.0047 32.0972Z"
        fill="black"
      />
      <Path
        d="M31.0816 30.7299C32.3354 30.7299 32.4509 30.8501 32.4494 32.1392C32.4494 33.3833 32.3132 33.5156 31.0372 33.5141C29.8337 33.5141 29.7153 33.3818 29.7168 32.0581C29.7168 30.8455 29.8352 30.7299 31.0816 30.7299Z"
        fill="black"
      />
      <Path
        d="M31.0552 25.3358C29.8251 25.3358 29.7156 25.2186 29.723 23.8948C29.723 22.6552 29.8488 22.535 31.1455 22.5425C32.3179 22.5425 32.457 22.6928 32.4555 23.9489C32.4541 25.2051 32.3238 25.3358 31.0552 25.3358Z"
        fill="black"
      />
      <Path
        d="M31.0254 29.4016C29.779 29.4016 29.7153 29.331 29.7168 27.9576C29.7168 26.7075 29.776 26.6549 31.1645 26.6579C32.3487 26.6579 32.4523 26.7766 32.4494 28.0643C32.4479 29.2994 32.3443 29.4031 31.0254 29.4016Z"
        fill="black"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1_3">
        <Rect
          width={27}
          height={26}
          fill="white"
          transform="translate(10 11)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);

export default LocationCity;
